<template>
  <div>
    <div
      v-if="loader"
      class="fixed inset-0 flex items-center justify-center bg-white z-50"
    >
      <img
        src="@/assets/imgs/tuin_loader_v2.gif"
        alt="cargando..."
        class="w-[500px]"
      >
    </div>

    <ToastAlert
      :is-active="toastAlert"
      :type="typeMsg"
      :message="msg"
    />

    <div class="items-center justify-center">
      <!-- Formulario -->
      <div class="mx-auto sm:max-w-4xl bg-white sm:mt-20">
				<div class="mb-4">
					<button
						class="py-2.5 px-2.5 rounded-full"
						@click="goBack"
					>
						<svg xmlns="http://www.w3.org/2000/svg" width="23" height="18" viewBox="0 0 23 18" fill="none">
							<path d="M9.93061 17.1115C9.63057 17.4115 9.22368 17.58 8.79941 17.58C8.37515 17.58 7.96826 17.4115 7.66821 17.1115L0.468214 9.9115C0.168261 9.61145 -0.000244141 9.20456 -0.000244141 8.7803C-0.000244141 8.35604 0.168261 7.94914 0.468214 7.6491L7.66821 0.449099C7.96998 0.157644 8.37414 -0.00362587 8.79366 1.90735e-05C9.21317 0.00366592 9.61447 0.171934 9.91112 0.468588C10.2078 0.765242 10.376 1.16654 10.3797 1.58606C10.3833 2.00557 10.2221 2.40973 9.93061 2.7115L5.59941 7.1803L20.7994 7.1803C21.2238 7.1803 21.6307 7.34887 21.9308 7.64893C22.2308 7.94899 22.3994 8.35595 22.3994 8.7803C22.3994 9.20464 22.2308 9.61161 21.9308 9.91167C21.6307 10.2117 21.2238 10.3803 20.7994 10.3803L5.59941 10.3803L9.93061 14.8491C10.2306 15.1491 10.3991 15.556 10.3991 15.9803C10.3991 16.4046 10.2306 16.8115 9.93061 17.1115Z" fill="black"/>
						</svg>
					</button>
				</div>
        <div>
          <h3 class="text-lg font-medium mb-6">
            Datos del Prospecto
          </h3>
          
          <!-- Formulario responsive con orden diferente en mobile vs desktop -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <!-- Campo 1: Nombre (mobile: 1, desktop: col 1 row 1) -->
            <div class="order-1 md:order-1">
              <p class="block mb-2 text-sm font-medium text-custom_gray dark:text-white">Nombre*</p>
              <input
                v-model="name"
                type="text"
                placeholder="Ingresa el nombre del contacto"
                class="bg-white h-11 border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5"
                required
              />
            </div>

            <!-- Campo 2: Apellido Paterno (mobile: 2, desktop: col 2 row 1) -->
            <div class="order-2 md:order-2">
              <p class="block mb-2 text-sm font-medium text-custom_gray dark:text-white">Apellido Paterno*</p>
              <input
                v-model="last_name"
                type="text"
                placeholder="Ingresa el apellido paterno"
                class="bg-white h-11 border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5"
                required
              />
            </div>

            <!-- Campo 3: Apellido Materno (mobile: 3, desktop: col 1 row 2) -->
            <div class="order-3 md:order-3">
              <p class="block mb-2 text-sm font-medium text-custom_gray dark:text-white">Apellido Materno*</p>
              <input
                v-model="second_last_name"
                type="text"
                placeholder="Ingresa el apellido materno"
                class="bg-white h-11 border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5"
                required
              />
            </div>

            <!-- Campo 4: Email (mobile: 4, desktop: col 1 row 3) -->
            <div class="order-4 md:order-5">
              <p class="block mb-2 text-sm font-medium text-custom_gray dark:text-white">Email</p>
              <input
                v-model="email"
                type="email"
                placeholder="Ingresa el correo electrónico"
                class="bg-white h-11 border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5"
                required
              />
            </div>

            <!-- Campo 5: Número de Celular (mobile: 5, desktop: col 2 row 2) -->
            <div class="order-5 md:order-4">
              <p class="block mb-2 text-sm font-medium text-custom_gray dark:text-white">Número de Celular*</p>
              
              <div class="flex gap-2">
                <div class="w-32">
                  <div class="custom-select-container">
                    <div class="selected-option" @click.stop="toggleDropdown">
                      <div v-if="selectedCountry" class="country-item">
                        <img 
                          v-if="getSelectedCountry && getSelectedCountry.flag" 
                          :src="getSelectedCountry.flag" 
                          :alt="`Bandera de ${getSelectedCountry.name}`" 
                          class="flag-img"
                        />
                        <span>{{ selectedCountry }}</span>
                      </div>
                      <div v-else class="placeholder">País</div>
                      <div class="arrow-down"></div>
                    </div>

                    <!-- Dropdown options -->
                    <div class="dropdown-menu" v-if="isDropdownOpen">
                      <div 
                        v-for="country in filteredCountries" 
                        :key="country.dial_code"
                        class="country-option"
                        @click="selectCountry(country.dial_code)"
                      >
                        <img 
                          v-if="country.flag" 
                          :src="country.flag" 
                          :alt="`Bandera de ${country.name}`" 
                          class="flag-img"
                        />
                        <span>({{ country.dial_code }})</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="flex-1">
                  <input 
                    type="text" 
                    v-model="phone" 
                    id="phone-input" 
                    class="bg-white h-11 border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5"
                    placeholder="Ingresa tu número celular" 
                    maxlength="10"
                    required 
                    @input="onlyNumbers" 
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Botones de acción -->
          <div class="flex items-end justify-end mt-8">
            <button
              @click="save"
              class="w-full font-medium sm:w-auto px-5 py-2.5 bg-tuin-100 text-white rounded-lg text-sm hover:bg-tuin_hover disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              {{ isEditMode ? 'Actualizar Prospecto' : 'Agregar Prospecto' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue"; 
import { useRouter, useRoute } from "vue-router";
import ToastAlert from "@/commond/ToastAlert.vue";
import axios from "axios";
import { useStore } from "vuex";

const router = useRouter();
const route = useRoute();
const store = useStore();
let session = computed(() => store.getters.getUserSession);

// Variables para detectar modo de edición
const isEditMode = computed(() => route.name === 'leads-edit');
const prospectId = computed(() => route.params.prospect_id);

// Variables del formulario
let name = ref("");
let last_name = ref("");
let second_last_name = ref("");
let email = ref("");
let phone = ref("");

// Variables para el selector de países
const countryCodes = ref([]);
const selectedCountry = ref("");
const isDropdownOpen = ref(false);

// Variables de estado
let loader = ref(false);
let toastAlert = ref(false);
let typeMsg = ref("");
let msg = ref("");

// Funciones para el selector de países
const getSelectedCountry = computed(() => {
  return countryCodes.value.find(country => country.dial_code === selectedCountry.value);
});

const filteredCountries = computed(() => {
  return [...countryCodes.value].sort((a, b) => a.name.localeCompare(b.name));
});

const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value;
};

const selectCountry = (dialCode) => {
  selectedCountry.value = dialCode;
  isDropdownOpen.value = false;
};

const onlyNumbers = (event) => {
  // Eliminar cualquier carácter que no sea número
  let value = event.target.value.replace(/[^0-9]/g, '');
  
  // Limitar a 10 caracteres
  if (value.length > 10) {
    value = value.substring(0, 10);
  }
  
  // Asignar el valor filtrado al input
  event.target.value = value;
  
  // Actualizar el modelo de Vue
  phone.value = value;
};

// Función para cerrar el dropdown cuando se hace clic fuera
const closeDropdown = (e) => {
  const container = document.querySelector('.custom-select-container');
  if (container && !container.contains(e.target)) {
    isDropdownOpen.value = false;
  }
};

// Cargar códigos de país desde la API
const loadCountryCodes = async () => {
  const token = session.value ? session.value.token_api : null;

  if (!token) {
    console.error("No se encontró token de sesión");
    return;
  }

  const url = `${process.env.VUE_APP_API_BASE_URL}/get-country-preferences`;
  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token.trim()}`,
    },
  };

  loader.value = true;

  try {
    const response = await axios.get(url, options);
    countryCodes.value = response.data;

    // Establecer México (+52) como predeterminado si está disponible
    if (countryCodes.value.length > 0 && !selectedCountry.value) {
      const mexicoCountry = countryCodes.value.find(c => c.dial_code === '+52');
      
      if (mexicoCountry) {
        selectedCountry.value = '+52';
      } else {
        selectedCountry.value = countryCodes.value[0].dial_code;
      }
    }
    loader.value = false;
  } catch (err) {
      loader.value = false;
    console.error("Error fetching data:", err);
  }
};

// Cargar datos del prospecto para edición
async function loadProspectData() {
  if (!isEditMode.value || !prospectId.value) return;
  
  loader.value = true;
  
  try {
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    let url_link = `${process.env.VUE_APP_API_BASE_URL}/broker/lead/${prospectId.value}`;

    const response = await axios.get(url_link, options);

    if (response.status == 401) {
      store.dispatch("clearUserSession");
      router.push({ name: 'login' });
      return;
    }

    if (response.status == 200) {
      let data = response.data.resp.info;
      
      name.value = data.name || '';
      last_name.value = data.last_name || '';
      second_last_name.value = data.second_last_name || '';
      email.value = data.email || '';
      phone.value = data.phone || '';
      
      // Establecer código de país si existe
      if (data.country_code) {
        selectedCountry.value = data.country_code;
      }
      
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    showToast('danger', 'Error al cargar los datos del prospecto');
  }
  
  loader.value = false;
}

// Funciones de validación y guardado
async function validateForm() {
  if (name.value == '' || name.value == null) {
    return { 'status': 'fail', 'message': 'El campo nombre es requerido' };
  }
  if (last_name.value == '' || last_name.value == null) {
    return { 'status': 'fail', 'message': 'El campo apellido paterno es requerido' };
  }
  if (second_last_name.value == '' || second_last_name.value == null) {
    return { 'status': 'fail', 'message': 'El campo apellido materno es requerido' };
  }
  if ((email.value == '' || email.value == null)) {
    return { 'status': 'fail', 'message': 'El campo email es requerido' };
  }

  if (!validateEmail(email.value)) {
    return { 'status': 'fail', 'message': 'Debes ingresar un correo válido' };
  }

  if (phone.value == '' || phone.value == null) {
    return { 'status': 'fail', 'message': 'El campo teléfono es requerido' };
  }
  return { 'status': 'ok', 'message': '' };
}

function validateEmail(email) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
}

async function save() {
  let form_post = {
    name: name.value,
    last_name: last_name.value,
    second_last_name: second_last_name.value,
    email: email.value,
    phone: phone.value,
    country_code: selectedCountry.value,
  };

  // Añadir lead_id para actualización
  if (isEditMode.value) {
    form_post.lead_id = prospectId.value;
  }

  let validation = await validateForm();

  if (validation.status !== 'ok') {
    showToast('danger', validation.message);
    return false;
  }
  
  loader.value = true;

  try {
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    let url_link, method;
    
    if (isEditMode.value) {
      // Modo edición - usar PUT
      url_link = `${process.env.VUE_APP_API_BASE_URL}/broker/lead/${session.value.id}/update`;
      method = 'put';
    } else {
      // Modo creación - usar POST
      url_link = `${process.env.VUE_APP_API_BASE_URL}/broker/lead/${session.value.id}/add`;
      method = 'post';
    }

    const response = await axios[method](url_link, form_post, options);

    if (response.status == 401) {
      loader.value = false;
      store.dispatch("clearUserSession");
      router.push({ name: 'login' });
      return;
    }

    if (response.status == 200) {
      loader.value = false;
      const message = isEditMode.value ? 
        'Prospecto actualizado correctamente' : 
        'Prospecto guardado correctamente';
      showToast('success', message);
      
      setTimeout(() => {
        router.push({ name: 'leads' });
      }, 2000);
    }
  } catch (error) {
    loader.value = false;
    if (error.response && error.response.status == 422) {
      const resp = error.response.data;
      if (resp.errors) {
        for (const field in resp.errors) {
          resp.errors[field].forEach((message) => {
            showToast('danger', message);
          });
        }
      }
    }
    console.error("Error al guardar:", error);
  }
}

async function showToast(type, message) {
  toastAlert.value = true;
  typeMsg.value = type;
  msg.value = message;

  setTimeout(() => {
    closeToast();
  }, 3000);
}

async function closeToast() {
  toastAlert.value = false;
  typeMsg.value = "";
  msg.value = "";
}

function goBack() {
  router.push({ name: 'leads' });
}

// Inicializar componente
onMounted(async () => {
  document.addEventListener('click', closeDropdown);
  
  // Cargar catálogos necesarios
  await loadCountryCodes();
  
  // Si estamos en modo edición, cargar datos del prospecto
  if (isEditMode.value && prospectId.value) {
    await loadProspectData();
  }
});

// Watch para detectar cambios en la ruta (si cambia de crear a editar)
watch(
  () => route.params.prospect_id,
  async (newProspectId) => {
    if (newProspectId && isEditMode.value) {
      await loadProspectData();
    }
  }
);
</script>

<style scoped>
.custom-select-container {
  position: relative;
  width: 100%;
  user-select: none;
}

.selected-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: white;
  cursor: pointer;
}

.country-item, .country-option {
  display: flex;
  align-items: center;
  gap: 8px;
}

.placeholder {
  color: #666;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #666;
  margin-left: 8px;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 200px;
  overflow-y: auto;
  background-color: white;
  border: 1px solid #ccc;
  border-top: none;
  border-radius: 0 0 8px 8px;
  z-index: 100;
}

.country-option {
  padding: 8px 12px;
  cursor: pointer;
}

.country-option:hover {
  background-color: #f5f5f5;
}

.flag-img {
  width: 24px;
  height: auto;
  vertical-align: middle;
  border: 1px solid #ddd;
}
</style>
